import { render, staticRenderFns } from "./Footr_gb.vue?vue&type=template&id=aaba8c86"
import script from "./Footr_gb.vue?vue&type=script&lang=js"
export * from "./Footr_gb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports